const CAMU9367871MOCK = {
  "containerNumber": "CAMU9367871",
  "vesselName": "MSC SAO PAULO",
  "ccn": "84531066ADB450",
  "tripCycleId": 2945123,
  "ehblManifestId": 1589,
  "ehblHblId": 27114,
  "aciocnA6aId": 68211,
  "isActiveTrip": true,
  "dexpUnifiedEvent": [
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 912,
      "eventCode": null,
      "eventDescription": "4",
      "eventTime": "2026-03-26 18:20:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "84531066ADB450",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88055
    },
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 1204,
      "eventCode": "0013",
      "eventDescription": "CUSTOMS_RELEASED",
      "eventTime": "2026-03-26 15:00:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "84531066ADB450",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 91004
    },
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 1203,
      "eventCode": "8003",
      "eventDescription": "CUSTOMS_ARRIVED",
      "eventTime": "2026-03-26 13:45:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "84531066ADB450",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 91003
    },
    {
      "sourceName": "PSA",
      "subSourceName": "VESSEL_SCHEDULE",
      "sourceEventId": 804,
      "eventCode": null,
      "eventDescription": "VESSEL_ETD",
      "eventTime": "2026-03-22 22:00:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "MSC SAO PAULO",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88021
    },
    {
      "sourceName": "PSA",
      "subSourceName": "ATLANTIC",
      "sourceEventId": 1202,
      "eventCode": null,
      "eventDescription": "RAIL_DEPARTURE",
      "eventTime": "2026-03-21 16:30:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "CAMU9367871",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 91002
    },
    {
      "sourceName": "PSA",
      "subSourceName": "ATLANTIC",
      "sourceEventId": 802,
      "eventCode": null,
      "eventDescription": "VESSEL_DISCHARGE",
      "eventTime": "2026-03-20 17:15:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "CAMU9367871",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88031
    },
    {
      "sourceName": "PSA",
      "subSourceName": "VESSEL_SCHEDULE",
      "sourceEventId": 801,
      "eventCode": null,
      "eventDescription": "VESSEL_ATA",
      "eventTime": "2026-03-20 10:30:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "MSC SAO PAULO",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88021
    },
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 908,
      "eventCode": null,
      "eventDescription": "5",
      "eventTime": "2026-03-19 15:45:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "84531066ADB450",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88055
    },
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 907,
      "eventCode": null,
      "eventDescription": "9",
      "eventTime": "2026-03-19 14:30:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "84531066ADB450",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88055
    },
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 906,
      "eventCode": null,
      "eventDescription": "0001",
      "eventTime": "2026-03-19 13:15:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "84531066ADB450",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88055
    },
    {
      "sourceName": "IID",
      "subSourceName": "IID",
      "sourceEventId": 905,
      "eventCode": null,
      "eventDescription": "IID_SUBMITTED",
      "eventTime": "2026-03-19 12:30:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "84531066ADB450",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88058
    },
    {
      "sourceName": "PSA",
      "subSourceName": "VESSEL_SCHEDULE",
      "sourceEventId": 800,
      "eventCode": null,
      "eventDescription": "VESSEL_ETA",
      "eventTime": "2026-03-18 18:00:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "MSC SAO PAULO",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88021
    },
    {
      "sourceName": "EHBL",
      "subSourceName": "HBL",
      "sourceEventId": 904,
      "eventCode": null,
      "eventDescription": "ACI_ACCEPTED",
      "eventTime": "2026-03-15 13:45:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "84531066ADB450",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 88057
    }
  ],
  "complianceSummary": {
    "master_level": {
      "total_primary_ccns": 2,
      "status_breakdown": [
        {
          "count": 2,
          "ui_label": "Accepted",
          "internal_enum": "ACI_ACCEPTED"
        },
        {
          "count": 0,
          "ui_label": "Submitted",
          "internal_enum": "ACI_SUBMITTED"
        },
        {
          "count": 0,
          "ui_label": "Rejected",
          "internal_enum": "ACI_REJECTED"
        }
      ]
    },
    "house_level": {
      "total_ehbls": 5,
      "status_breakdown": [
        {
          "count": 5,
          "ui_label": "Accepted",
          "internal_enum": "ACI_ACCEPTED"
        },
        {
          "count": 0,
          "ui_label": "Submitted",
          "internal_enum": "ACI_SUBMITTED"
        },
        {
          "count": 0,
          "ui_label": "Rejected",
          "internal_enum": "ACI_REJECTED"
        },
        {
          "count": 0,
          "ui_label": "Released",
          "internal_enum": "CUSTOMS_RELEASED"
        },
        {
          "count": 0,
          "ui_label": "Held",
          "internal_enum": "CUSTOMS_HOLD"
        }
      ]
    }
  }
};

const TGBU9367871MOCK = {
  "containerNumber": "TGBU9367871",
  "vesselName": "ZIM FELIXSTOWE",
  "ccn": "91469367814352",
  "tripCycleId": 3057811,
  "ehblManifestId": 1692,
  "ehblHblId": 28941,
  "aciocnA6aId": 70188,
  "isActiveTrip": true,
  "dexpUnifiedEvent": [
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 1012,
      "eventCode": null,
      "eventDescription": "4",
      "eventTime": "2026-03-26 13:30:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "91469367814352",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99055
    },
    {
      "sourceName": "PSA",
      "subSourceName": "VESSEL_SCHEDULE",
      "sourceEventId": 1104,
      "eventCode": null,
      "eventDescription": "VESSEL_ETD",
      "eventTime": "2026-03-22 14:00:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "ZIM FELIXSTOWE",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99021
    },
    {
      "sourceName": "PSA",
      "subSourceName": "ATLANTIC",
      "sourceEventId": 1103,
      "eventCode": null,
      "eventDescription": "RAIL_DEPARTURE",
      "eventTime": "2026-03-21 10:15:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "TGBU9367871",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99031
    },
    {
      "sourceName": "PSA",
      "subSourceName": "ATLANTIC",
      "sourceEventId": 1102,
      "eventCode": null,
      "eventDescription": "VESSEL_DISCHARGE",
      "eventTime": "2026-03-20 15:30:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "TGBU9367871",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99031
    },
    {
      "sourceName": "PSA",
      "subSourceName": "VESSEL_SCHEDULE",
      "sourceEventId": 1101,
      "eventCode": null,
      "eventDescription": "VESSEL_ATA",
      "eventTime": "2026-03-20 11:45:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "ZIM FELIXSTOWE",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99021
    },
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 1008,
      "eventCode": null,
      "eventDescription": "9",
      "eventTime": "2026-03-19 17:20:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "91469367814352",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99055
    },
    {
      "sourceName": "CUSTOMS_RELEASE",
      "subSourceName": "D4NOTICE",
      "sourceEventId": 1007,
      "eventCode": null,
      "eventDescription": "0001",
      "eventTime": "2026-03-19 15:45:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "91469367814352",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99055
    },
    {
      "sourceName": "IID",
      "subSourceName": "IID",
      "sourceEventId": 1006,
      "eventCode": null,
      "eventDescription": "IID_SUBMITTED",
      "eventTime": "2026-03-19 14:00:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "91469367814352",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99058
    },
    {
      "sourceName": "PSA",
      "subSourceName": "VESSEL_SCHEDULE",
      "sourceEventId": 1100,
      "eventCode": null,
      "eventDescription": "VESSEL_ETA",
      "eventTime": "2026-03-18 12:00:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "ZIM FELIXSTOWE",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99021
    },
    {
      "sourceName": "ACIOCN",
      "subSourceName": "A6A",
      "sourceEventId": 1005,
      "eventCode": null,
      "eventDescription": "ACI_ACCEPTED",
      "eventTime": "2026-03-15 15:30:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "91469367814352",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99060
    },
    {
      "sourceName": "ACIOCN",
      "subSourceName": "A6A",
      "sourceEventId": 1004,
      "eventCode": null,
      "eventDescription": "ACI_REJECTED",
      "eventTime": "2026-03-15 14:05:00.000000",
      "isRemoved": false,
      "removedDate": null,
      "sourceReferenceNo": "91469367814352",
      "messageFunction": null,
      "dexpUnifiedHeader": null,
      "unifiedHeaderId": 99060
    }
  ],
  "complianceSummary": {
    "master_level": {
      "total_primary_ccns": 2,
      "status_breakdown": [
        {
          "count": 2,
          "ui_label": "Accepted",
          "internal_enum": "ACI_ACCEPTED"
        },
        {
          "count": 0,
          "ui_label": "Submitted",
          "internal_enum": "ACI_SUBMITTED"
        },
        {
          "count": 0,
          "ui_label": "Rejected",
          "internal_enum": "ACI_REJECTED"
        }
      ]
    },
    "house_level": {
      "total_ehbls": 5,
      "status_breakdown": [
        {
          "count": 4,
          "ui_label": "Accepted",
          "internal_enum": "ACI_ACCEPTED"
        },
        {
          "count": 0,
          "ui_label": "Submitted",
          "internal_enum": "ACI_SUBMITTED"
        },
        {
          "count": 1,
          "ui_label": "Rejected",
          "internal_enum": "ACI_REJECTED"
        },
        {
          "count": 0,
          "ui_label": "Released",
          "internal_enum": "CUSTOMS_RELEASED"
        },
        {
          "count": 0,
          "ui_label": "Held",
          "internal_enum": "CUSTOMS_HOLD"
        }
      ]
    }
  }
};

const resolveMockTracking = (searchInput, trackingType, { processContainerTrackingData, processTrackingData, PSA_SOURCE, SIMULATION_DELAY }) => {

  return new Promise((resolve) => {
    let processedData
    let mockDataBase = { dexpUnifiedEvent: [] }

    if (trackingType === 'CONTAINER') {

      if (searchInput.toUpperCase() === 'CAMU9367871') {
        mockDataBase = CAMU9367871MOCK
      }

      if (searchInput.toUpperCase() === 'TGBU9367871') {
        mockDataBase = TGBU9367871MOCK
      }

      const filteredEvents = Array.isArray(mockDataBase?.dexpUnifiedEvent)
        ? mockDataBase.dexpUnifiedEvent.filter(e => e?.sourceName === PSA_SOURCE)
        : []
      processedData = processContainerTrackingData({ ...mockDataBase, dexpUnifiedEvent: filteredEvents })

    } else {

      if (searchInput.toUpperCase() === '84531066ADB450') {
        mockDataBase = CAMU9367871MOCK
      }

      if (searchInput.toUpperCase() === '91469367814352') {
        mockDataBase = TGBU9367871MOCK
      }

      processedData = processTrackingData(mockDataBase)
    }
    setTimeout(() => resolve(processedData), SIMULATION_DELAY)
  })

}

export { resolveMockTracking }